export default {
    init(state,data){
        state.linkList = data.linkList;
        state.bestNews = data.bestNews;
        state.systemInfo = data.systemInfo;
    },
    home(state,data){
        state.home = data;
    },
    bottomNews(state,data){
        state.bottomNews = data;
    },
    columns(state,data){
        state.columns = data;
    },
    // 产品部分
    productColumns(state,data){
        state.productColumns = data;
    },
    productList(state,data){
        state.productList = data;
    },
    productTotal(state,data){
        state.productTotal = data;
    },
    // 新闻中心
    newsColumns(state,data){
        state.newsColumns = data;
    },
    newsList(state,data){
        state.newsList = data;
    },
    newsTotal(state,data){
        state.newsTotal = data;
    },
    setColumnClass(state,data){
        state.columnClass = data;
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js